import dynamic from 'next/dynamic'

import { DealFragment } from '~generated/operations'
import Loader from '~lib/ui-kit/Loader'
import Modal from '~lib/ui-kit/Modal'
import Space from '~lib/ui-kit/Space'

const AttachDealsModalContent = dynamic(() => import('./AttachDealsModalContent'), {
  loading: () => {
    return (
      <Space align="center" justify="center">
        <Loader />
      </Space>
    )
  },
})

interface AttachDealsModalProps {
  opened: boolean
  deals: DealFragment[]
  onAttach: (value: DealFragment[]) => void
  onClose: () => void
  disabled?: boolean
  readOnly?: boolean
}

function AttachDealsModal({ opened, deals, onAttach, onClose, disabled, readOnly }: AttachDealsModalProps) {
  return (
    <Modal opened={opened} onEscapePress={onClose} overlayVariant="dark">
      <AttachDealsModalContent
        deals={deals}
        onChange={onAttach}
        onClose={onClose}
        disabled={disabled}
        readOnly={readOnly}
      />
    </Modal>
  )
}

export default AttachDealsModal
